import { ListItem } from "@mui/material";
import { SxProps } from "@mui/system";
import { useCallback } from "react";
import { useAppSelector } from "../../../../../app/hooks";
import { NameIdOption } from "../../../../../common/types/commonTypes";
import { selectLanguageSkillsArray } from "../../../../../features/languageSkills/languageSkillsSlice";
import AutocompleteBase from "../autocompleteBase/AutocompleteBase";
import { handleAutocompleteChange } from "../helpers";

interface Props {
  value?: NameIdOption[];
  onChange?: (languageSkills: NameIdOption[] | null) => void;
  multiple?: boolean;
  disabled?: boolean;
  fullWidth?: boolean;
  size?: "small" | "medium";
  limitTags?: number;
  sx?: SxProps;
}

const LanguageSkillsAutocomplete = ({
  value,
  onChange,
  multiple = true,
  disabled = false,
  fullWidth = true,
  size = "small",
  limitTags,
  sx = {},
}: Props) => {
  const languageSkills = useAppSelector((state) =>
    selectLanguageSkillsArray(state),
  );

  const languageSkillOptions: NameIdOption[] = languageSkills.map((lang) => ({
    id: lang.code,
    name: lang.name,
  }));

  const handleChange = useCallback(
    (newValue: NameIdOption | NameIdOption[] | null) => {
      handleAutocompleteChange(newValue, onChange, multiple);
    },
    [onChange, multiple],
  );

  const getOptionLabel = (option: NameIdOption) => option.name;
  const isOptionEqualToValue = (option: NameIdOption, val: NameIdOption) =>
    option.id === val.id;

  return (
    <AutocompleteBase<NameIdOption>
      value={value || []}
      onChange={(newValue) => handleChange(newValue)}
      options={languageSkillOptions}
      getOptionLabel={getOptionLabel}
      isOptionEqualToValue={isOptionEqualToValue}
      multiple={multiple}
      fullWidth={fullWidth}
      disabled={disabled}
      limitTags={limitTags}
      size={size}
      renderOption={(props, option) => (
        <ListItem {...props} key={option.id}>
          {option.name}
        </ListItem>
      )}
      sx={sx}
    />
  );
};

export default LanguageSkillsAutocomplete;
